import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "view", "viewTitle", "form", "saveBtn", "nameInput", "emailInput", "councilInput", "councilStateInput",
    "prefixInput", "phoneInput", "notesInput", "addNewLeadBtn", "checklist", "linkInput",
    "sourceDropdown", "sourceDropdownBtn", "sourceInput", "sourceList", "statusDropdown", "statusDropdownBtn", "statusInput", "statusList",
    "chekListName", "checkListDescriptionName", "checkListEmail", "checkListDescriptionEmail",
    "checkListPhone", "checkListDescriptionPhone", "checkListCouncilState", "checkListDescriptionCouncilState",
    "checkListSource", "checkListDescriptionSource", "checkListNotes", "checkListDescriptionNotes",
    "checkListOffice", "checkListDescriptionOffice", "checkListSignature", "checkListDescriptionSignature",
    "checkListCouncil", "checkListDescriptionCouncil", "checkListPrefix", "checkListDescriptionPrefix"]


  connect() {
    this.current_lead = {}
    this.application.permissions = {}
    this.loader = this.getControllerByIdentifier("app--helpers--loaders").loader()
    this.cardLoader = this.getControllerByIdentifier("app--helpers--loaders").cardLoader()
    this.controllerName = `commercial--sales--leads--entities--index`
    this.doPageGrid()
    console.log(`index`)
  }

  doPageGrid() {
    this.stopRefreshing()
    var html = `<div class="row my-4">
                  <div class="col-4 pr-1" data-controller="commercial--sales--leads--sources--events" data-commercial--sales--leads--sources--events-target="main"></div>
                  <div class="col-4 px-1" data-controller="commercial--sales--leads--sources--landings" data-commercial--sales--leads--sources--landings-target="main"></div>
                  <div class="col-4 pl-1" data-controller="commercial--sales--leads--sources--visits" data-commercial--sales--leads--sources--visits-target="main"></div>
                </div>
                <div class="row my-4">
                  <div class="col-4">
                    <div class="row">
                      <div class="col-12 px-0">
                        <div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="view">
                          <div class="card-header d-flex align-items-center card-header-table-list f-065">
                            <h6 class="card-title display-4" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Selecione um Lead e gere um novo SQL</h6>
                            <div class="card-actions ml-auto py-0 mc-tooltip">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="addNewLeadBtn" data-action="click->${this.controllerName}#addNewLead" type="button">
                                <span class="material-icons">add</span>
                              </button>
                              <span class="mc-tooltiptext">Adicionar Novo Lead</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row my-4" data-${this.controllerName}-target="checklist">
                    </div>
                  </div>
                  <div class="col-8" data-${this.controllerName}-target="form"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.getCurrentUserPermissions()
    }) 
  }

  addNewLead() {
    this.current_lead = {}
    this.doFormHtml()
  }

  doFormHtml() {
    this.stopRefreshing()
    if (this.application.permissions.sales_qualified_leads.can_create) {
      var saveBtnHtml = `<button disabled type="button" class="btn btn-primary btn-sm btn-table f-065" data-action="click->${this.controllerName}#saveSalesLead" data-${this.controllerName}-target="saveBtn">Salvar SQL</button>`
    } else {
      var saveBtnHtml = ``
    }

    var html = `<div class="card" style="width:100%;display:relative;">
                  
                  <div class="card-body py-0" style="overflow:auto;" data-${this.controllerName}-target="formCardBody">
                    <div class="row my-2">
                      <div class="col-6 pl-0 pr-2">
                        <div class="row my-2">
                          <div class="col-8 pl-0 pr-2">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="nameForm">Nome</label>
                                <input aria-describedby="nameFormHelp" class="form-control" id="nameForm" data-${this.controllerName}-target="nameInput" placeholder="Nome" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 pl-2 pr-0">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label>Fonte</label>
                                <div class="dropdown dropdown-selector" data-controller="app--helpers--search app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="sourceDropdown">
                                  <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="sourceDropdownBtn"><span class="mr-auto w-100 selected-item" data-app--helpers--selector-target="input" data-${this.controllerName}-target="sourceInput"></span></button>
                                  <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                    <input class="form-control form-control-selector" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchList" type="text" placeholder="Buscar ...">
                                    <ul class="ul-select" data-${this.controllerName}-target="sourceList" data-app--helpers--search-target="searchList">
                                      <li data-source="base" data-source-type="base" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Base</li>
                                      <li data-source="referrer" data-source-type="referrer" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Indicação</li>
                                      <li data-source="direct" data-source-type="direct" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Direto</li>
                                      <li data-source="outbound" data-source-type="outbound" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Outbound</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="row my-2">
                          <div class="col-8 pl-0 pr-2">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="emailForm">E-mail</label>
                                <input aria-describedby="emailFormHelp" class="form-control" id="emailForm" data-${this.controllerName}-target="emailInput" placeholder="Nome" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 pl-2 pr-0">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label>Estágio</label>
                                <div class="dropdown dropdown-selector" data-controller="app--helpers--search app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="statusDropdown">
                                  <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="statusDropdownBtn"><span class="mr-auto w-100 selected-item" data-app--helpers--selector-target="input" data-${this.controllerName}-target="statusInput"></span></button>
                                  <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                    <input class="form-control form-control-selector" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchList" type="text" placeholder="Buscar ...">
                                    <ul class="ul-select" data-${this.controllerName}-target="statusList" data-app--helpers--search-target="searchList">
                                      <li data-status="in_process" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Em Processo</li>
                                      <li data-status="gain" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Ganho</li>
                                      <li data-status="lost" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Perdido</li>
                                      <li data-status="not_contact" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Não Contactado</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row my-2">
                          <div class="col-4 pl-0 pr-2">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="councilForm">CRM</label>
                                <input aria-describedby="councilFormHelp" class="form-control" id="councilForm" data-${this.controllerName}-target="councilInput" placeholder="CRM" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-2 pl-2 pr-2">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="councilStateForm">UF CRM</label>
                                <input aria-describedby="councilStateFormHelp" class="form-control" id="councilStateForm" data-${this.controllerName}-target="councilStateInput" placeholder="UF CRM" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-2 pl-2 pr-2">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="prefixForm">DDD</label>
                                <input aria-describedby="prefixFormHelp" class="form-control" id="prefixForm" data-${this.controllerName}-target="prefixInput" data-action="blur->${this.controllerName}#prefixMask keyup->${this.controllerName}#prefixMask keypress->${this.controllerName}#prefixMask" placeholder="DDD" type="tel" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-4 pl-2 pr-0">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="phoneForm">Telefone</label>
                                <input aria-describedby="phoneFormHelp" class="form-control" id="phoneForm" data-${this.controllerName}-target="phoneInput" data-action="blur->${this.controllerName}#phoneMask keyup->${this.controllerName}#phoneMask keypress->${this.controllerName}#phoneMask" placeholder="Número" type="tel" required>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-6 pr-0 pl-2">
                        <div class="row my-2">
                          <div class="col-12">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="linkForm">Link Minha MedCapital</label>
                                <input aria-describedby="linkFormHelp" class="form-control" id="linkForm" data-${this.controllerName}-target="linkInput" placeholder="Link Minha MedCapital" type="text" required>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row my-2">
                          <div class="col-12">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="notesForm">Anotações</label>
                                <textarea aria-describedby="notesFormHelp" class="form-control textarea px-0" id="notesForm" data-${this.controllerName}-target="notesInput" placeholder="Anotações" type="text" required rows="4"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>                    
                  </div>
                  <div class="card-footer border-top text-right py-1">
                    <button type="button" class="btn btn-secondary btn-sm btn-table f-065" data-action="click->${this.controllerName}#cancelSave">Fechar</button>
                    ${saveBtnHtml}
                  </div>
                </div>`


    var controller = this
    new Promise(function (resolve) {
      resolve(controller.formTarget.innerHTML = html)
    }).then(() => {
      var date = new Date()

      if (controller.current_lead.id) {
        controller.viewTitleTarget.innerText = `Novo SQL: ${this.current_lead.name}`
        controller.addNewLeadBtnTarget.classList.add("d-none")

        controller.nameInputTarget.value = controller.current_lead.name
        // controller.nameInputTarget.disabled = true

        controller.emailInputTarget.value = controller.current_lead.email
        // controller.emailInputTarget.disabled = true

        controller.councilInputTarget.value = controller.current_lead.crm
        // controller.councilInputTarget.disabled = true
        controller.councilStateInputTarget.value = controller.current_lead.crm_state
        // controller.councilStateInputTarget.disabled = true

        controller.prefixInputTarget.value = controller.current_lead.ddd
        // controller.prefixInputTarget.disabled = true
        if (controller.current_lead.number) {
          controller.phoneInputTarget.value = controller.getControllerByIdentifier("app--helpers--numbers").phoneMask(controller.current_lead.number)
        }
        // controller.phoneInputTarget.disabled = true

        controller.sourceInputTarget.innerText = controller.current_lead.source_pretty
        controller.sourceInputTarget.dataset.source = controller.current_lead.source
        controller.sourceInputTarget.dataset.sourceType = controller.current_lead.source_type
        controller.sourceDropdownTarget.value = controller.current_lead.source
        controller.sourceDropdownBtnTarget.disabled = true

      } else {
        controller.viewTitleTarget.innerText = `Novo SQL`
        controller.addNewLeadBtnTarget.classList.add("d-none")
        controller.sourceInputTarget.innerText = ``
        controller.sourceInputTarget.dataset.source = ``
        controller.sourceDropdownTarget.value = ``
      }

      controller.statusInputTarget.innerText = `Não Contactado`
      controller.statusInputTarget.dataset.status = `not_contact`
      controller.statusDropdownTarget.value = `not_contact`
      controller.statusDropdownBtnTarget.disabled = true

      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
      controller.refreshSaveBtn()
      controller.doCheckListHtml()
    })
  }

  doCheckListHtml() {
    var html = `<div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="chekListName" data-${this.controllerName}-target="chekListName">
                      <label class="custom-control-label pointer" for="chekListName"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionName"></span>
                  </div>
                  <div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="checkListEmail" data-${this.controllerName}-target="checkListEmail">
                      <label class="custom-control-label pointer" for="checkListEmail"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionEmail"></span>
                  </div>
                  <div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="checkListCouncil" data-${this.controllerName}-target="checkListCouncil">
                      <label class="custom-control-label pointer" for="checkListCouncil"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionCouncil"></span>
                  </div>
                  <div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="checkListPrefix" data-${this.controllerName}-target="checkListPrefix">
                      <label class="custom-control-label pointer" for="checkListPrefix"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionPrefix"></span>
                  </div>
                  <div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="checkListCouncilState" data-${this.controllerName}-target="checkListCouncilState">
                      <label class="custom-control-label pointer" for="checkListCouncilState"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionCouncilState"></span>
                  </div>
                  <div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="checkListPhone" data-${this.controllerName}-target="checkListPhone">
                      <label class="custom-control-label pointer" for="checkListPhone"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionPhone"></span>
                  </div>
                  <div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="checkListSource" data-${this.controllerName}-target="checkListSource">
                      <label class="custom-control-label pointer" for="checkListSource"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionSource"></span>
                  </div>
                  <div class="col-6 d-flex align-items-center my-1">
                    <div class="custom-control custom-checkbox px-0">
                      <input disabled type="checkbox" class="custom-control-input" id="checkListNotes" data-${this.controllerName}-target="checkListNotes">
                      <label class="custom-control-label pointer" for="checkListNotes"></label>
                    </div>
                    <span class="f-065 ml-3" data-${this.controllerName}-target="checkListDescriptionNotes"></span>
                  </div>`


    this.checklistTarget.innerHTML = html
  }

  cancelSave() {
    this.stopRefreshing()
    this.viewTitleTarget.innerText = `Selecione um Lead e gere um novo SQL`
    this.addNewLeadBtnTarget.classList.remove("d-none")
    this.formTarget.innerHTML = ``
    this.checklistTarget.innerHTML = ``
  }

  prefixMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToDDD(ev)
  }

  phoneMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToPhone(ev)
  }

  saveSalesLead() {
    this.stopRefreshing()
    this.saveBtnTarget.disabled = true
    this.send_data = { current_user: {}, lead: {}, source: {} }

    this.send_data.source.source = this.sourceInputTarget.dataset.source
    this.send_data.source.source_id = this.current_lead.source_id
    this.send_data.source.source_type = this.sourceInputTarget.dataset.sourceType

    this.send_data.lead.name = this.nameInputTarget.value.trim()
    this.send_data.lead.primary_source = this.sourceInputTarget.dataset.source
    this.send_data.lead.email = this.emailInputTarget.value.trim()
    this.send_data.lead.status = this.statusInputTarget.dataset.status
    this.send_data.lead.council_type = `CRM`
    this.send_data.lead.council_number = this.councilInputTarget.value.trim()
    this.send_data.lead.council_state = this.councilStateInputTarget.value.trim()
    this.send_data.lead.prefix = this.prefixInputTarget.value.trim()
    this.send_data.lead.phone = this.getControllerByIdentifier("app--helpers--numbers").fromPhoneToNumber(this.phoneInputTarget.value.trim())
    this.send_data.lead.notes = this.notesInputTarget.value.trim()
    this.send_data.lead.link = this.linkInputTarget.value.trim()

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = `sales_qualified_leads`

    this.requestSave()
  }

  requestSave() {
    var url = "/commercial/sales/leads/entities/create"
    var method = "POST"
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          controller.current_lead.sql = true
          controller.refreshLeadTables()
        }
        controller.cancelSave()
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  refreshLeadTables() {
    if (this.current_lead.source == `event`) {
      var leads = this.getControllerByIdentifier("commercial--sales--leads--sources--events").leads

      leads.forEach((element, i) => {
        if (element.id == this.current_lead.id) {
          leads.splice(leads.indexOf(element), 1, this.current_lead)
        }
      })

      this.getControllerByIdentifier("commercial--sales--leads--sources--events").leads = leads
      this.getControllerByIdentifier("commercial--sales--leads--sources--events").doDataTable()
    } else if (this.current_lead.source == `landing`) {
      var leads = this.getControllerByIdentifier("commercial--sales--leads--sources--landings").leads

      leads.forEach((element, i) => {
        if (element.id == this.current_lead.id) {
          leads.splice(leads.indexOf(element), 1, this.current_lead)
        }
      })

      this.getControllerByIdentifier("commercial--sales--leads--sources--landings").leads = leads
      this.getControllerByIdentifier("commercial--sales--leads--sources--landings").doDataTable()
    } else if (this.current_lead.source == `visit`) {
      var leads = this.getControllerByIdentifier("commercial--sales--leads--sources--visits").leads

      leads.forEach((element, i) => {
        if (element.id == this.current_lead.id) {
          leads.splice(leads.indexOf(element), 1, this.current_lead)
        }
      })

      this.getControllerByIdentifier("commercial--sales--leads--sources--visits").leads = leads
      this.getControllerByIdentifier("commercial--sales--leads--sources--visits").doDataTable()
    }
  }

  getCurrentUserPermissions() {
    const featureNames = ["commercial", "event_attendees", "sales_qualified_leads", "leads", "ahoy_visit"]
    const data = { permission: { features: featureNames }, current_user: { current_user_id: this.application.current_user.id } }
    const url = "/users/permissions/list_by_features"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        response.data.cln.forEach(permission => {
          controller.application.permissions[permission.name] = permission.data
        })
        controller.getControllerByIdentifier("commercial--sales--leads--sources--events").getLeads()
        controller.getControllerByIdentifier("commercial--sales--leads--sources--landings").getLeads()
        controller.getControllerByIdentifier("commercial--sales--leads--sources--visits").getLeads()

        controller.getControllerByIdentifier(`commercial--sales--leads--entities--submenu`).doSubmenuHtml()

        if (controller.application.permissions.sales_qualified_leads.can_create == false) {
          controller.addNewLeadBtnTarget.classList.add("d-none")
        }
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    
    this.refreshTimer = setInterval(function () {
      var len = 0

      if (controller.nameInputTarget.value == ``) {
        len += 1
        controller.chekListNameTarget.checked = false
        controller.checkListDescriptionNameTarget.innerHTML = `<span>Nome do Lead</span>`
      } else {
        controller.chekListNameTarget.checked = true
        controller.checkListDescriptionNameTarget.innerHTML = `<span><s>Nome do Lead</s></span>`
      }

      if (controller.emailInputTarget.value == ``) {
        len += 1
        controller.checkListEmailTarget.checked = false
        controller.checkListDescriptionEmailTarget.innerHTML = `<span>E-mail do Lead</span>`
      } else {
        controller.checkListEmailTarget.checked = true
        controller.checkListDescriptionEmailTarget.innerHTML = `<span><s>E-mail do Lead</s></span>`
      }

      if (controller.councilInputTarget.value == ``) {
        len += 1
        controller.checkListCouncilTarget.checked = false
        controller.checkListDescriptionCouncilTarget.innerHTML = `<span>Número do Conselho</span>`
      } else {
        controller.checkListCouncilTarget.checked = true
        controller.checkListDescriptionCouncilTarget.innerHTML = `<span><s>Número do Conselho</s></span>`
      }
      if (controller.councilStateInputTarget.value == ``) {
        len += 1
        controller.checkListCouncilStateTarget.checked = false
        controller.checkListDescriptionCouncilStateTarget.innerHTML = `<span>UF do Conselho</span>`
      } else {
        controller.checkListCouncilStateTarget.checked = true
        controller.checkListDescriptionCouncilStateTarget.innerHTML = `<span><s>UF do Conselho</s></span>`
      }

      if (controller.prefixInputTarget.value == ``) {
        len += 1
        controller.checkListPrefixTarget.checked = false
        controller.checkListDescriptionPrefixTarget.innerHTML = `<span>DDD</span>`
      } else {
        controller.checkListPrefixTarget.checked = true
        controller.checkListDescriptionPrefixTarget.innerHTML = `<span><s>DDD</s></span>`
      }
      if (controller.phoneInputTarget.value == ``) {
        len += 1
        controller.checkListPhoneTarget.checked = false
        controller.checkListDescriptionPhoneTarget.innerHTML = `<span>Telefone</span>`
      } else {
        controller.checkListPhoneTarget.checked = true
        controller.checkListDescriptionPhoneTarget.innerHTML = `<span><s>Telefone</s></span>`
      }

      if (controller.sourceInputTarget.innerText == ``) {
        len += 1
        controller.checkListSourceTarget.checked = false
        controller.checkListDescriptionSourceTarget.innerHTML = `<span>Fonte Primária</span>`
      } else {
        controller.checkListSourceTarget.checked = true
        controller.checkListDescriptionSourceTarget.innerHTML = `<span><s>Fonte Primária</s></span>`
      }

      if (controller.statusInputTarget.innerText == ``) {
        len += 1
      }

      if (controller.notesInputTarget.value == ``) {
        len += 1
        controller.checkListNotesTarget.checked = false
        controller.checkListDescriptionNotesTarget.innerHTML = `<span>Anotações</span>`
      } else {
        controller.checkListNotesTarget.checked = true
        controller.checkListDescriptionNotesTarget.innerHTML = `<span><s>Anotações</s></span>`
      }

      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
